import { useEffect, useState } from 'react'
import {
  useLazyGetCustomersDetailsByCodeQuery,
  useLazyGetCustomersQuery,
} from '../../api/app/CustomerApiService'
import { CustomersData } from '../../interface/response/CustomerResponse'
import {
  CUSTOMER_STATUS,
  eventKeyToKeyMap,
} from '../../components/customers/customerConstants'

const useCustomerList = () => {
  const [getCustomersList, customerList] = useLazyGetCustomersQuery()
  const [selectedCustomer, setSelectedCustomer] = useState<string | undefined>()
  const [showCustomerDetailsForm, setShowCustomerDetailsForm] =
    useState<boolean>(false)
  const [getCustomerDetails, customerDetails] =
    useLazyGetCustomersDetailsByCodeQuery()
  const [query, setQuery] = useState('')
  const [filteredList, setFilteredList] = useState<CustomersData[] | undefined>(
    customerList?.data,
  )
  const [selectedTab, setSelectedTab] = useState<string>(
    CUSTOMER_STATUS.PENDING.eventKey,
  )
  const [checkBoxValue, setCheckBoxValue] = useState(false)

  const handleCheckBox = () => {
    setCheckBoxValue(!checkBoxValue)
  }

  const handleCustomerForm = (value: boolean) => {
    setShowCustomerDetailsForm(value)
  }

  useEffect(() => {
    const status: string = eventKeyToKeyMap[selectedTab].toString()
    getCustomersList({ status: status })
    setSelectedCustomer(undefined)
  }, [selectedTab, getCustomersList])

  useEffect(() => {
    if (
      !customerList?.isFetching &&
      customerList?.data &&
      customerList?.data?.length > 0
    ) {
      if (!selectedCustomer) {
        setSelectedCustomer(customerList?.data?.[0]?.customerCode)
        setCheckBoxValue(false)
      }
    }
  }, [customerList?.data])

  useEffect(() => {
    if (selectedCustomer) {
      getCustomerDetails(selectedCustomer)
    }
  }, [selectedCustomer, getCustomerDetails])

  useEffect(() => {
    const latestData = customerList?.data?.filter((item: CustomersData) =>
      item?.customerName?.toLowerCase().includes(query?.toLowerCase()),
    )
    setFilteredList(latestData)
    if (!latestData || latestData?.length <= 0) {
      setSelectedCustomer(undefined)
    }
  }, [query, customerList?.data])

  const handleTabSelection = (key: string) => {
    setSelectedTab(key)
  }
  const handleCustomerSelection = (code: string) => {
    setSelectedCustomer(code)
    setCheckBoxValue(false)
  }

  const onSearchQueryHandler = (e: React.SyntheticEvent) => {
    const target = e.target as HTMLInputElement
    setQuery(target.value)
  }

  return {
    customerList,
    selectedTab,
    selectedCustomer,
    customerDetails,
    filteredList,
    query,
    handleTabSelection,
    onSearchQueryHandler,
    handleCustomerSelection,
    checkBoxValue,
    handleCheckBox,
    handleCustomerForm,
    showCustomerDetailsForm,
    setSelectedCustomer,
  }
}

export default useCustomerList
